export default __webpack_public_path__ + "945bc065ad66ed4f291c770cb456ef3e.png";